import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import Pagination from '../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import { ErrorMessage } from '../../validation/validationError';
import { appInstituteSectionGradeMappingFormValidation } from '../../validation/Validation';
import { ZodError } from 'zod';

const AppInstituteSectionGradeMapping = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        sectionMasterId: '',
        instituteGradeMasterIds: []
    }

    const [sectionList, setSectionList] = useState([]);
    const [instituteGradeList, setInstituteGradeList] = useState([]);
    const [sectionGradeData, setSectionGradeData] = useState(initialFormState)
    const [sectionGradeList, setSectionGradeList] = useState([])
    const [editId, setEditId] = useState(null)
    const [error, setError] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    
    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [gradeNameSort, setGradeNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionMasterDetails.sectionName", "instituteGradeMasterDetails.gradeName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSectionGradeList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setSectionGradeList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), 'data'))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(sectionGradeList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(sectionGradeList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > sectionGradeList.length) {
            endIndex = sectionGradeList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(sectionGradeList.slice(startIndex, endIndex));
    }, [sectionGradeList, currPage, itemsPerPage]);

    useEffect(() => {
        getSectionList();
        getInstituteGrade();
    }, []);

    useEffect(() => {
        getSectionGradeList();
    }, [sectionGradeData.sectionMasterId])

    const getApiUrl = () => {
        let apiUrl = '/get-institute-grade-section-mapping?';
        if (sectionGradeData.sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionGradeData.sectionMasterId}&`;
        }
        return apiUrl.replace(/&$/, '');
    }

    const getSectionGradeList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSectionGradeList(response.data.data);
        } catch (error) {
            setSectionGradeList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.log(errorMsg);
        }
    }

    const getSectionList = () => {
        const apiUrlForSection = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSection)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getInstituteGrade = async () => {
        try {
            const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            const grades = response.data.result.map(grade => {
                return {
                    value: grade.id,
                    label: grade.gradeName
                }
            })
            
            setInstituteGradeList(grades);
        } catch (error) {
            setInstituteGradeList([]);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.log(errorMsg)
        }
    }

    const addGrade = async () => {
        // if (isValid()) {
            try {
                await appInstituteSectionGradeMappingFormValidation.parseAsync(sectionGradeData);
                setError([]);
                setLoading(true);
                const apiUrl = `/add-institute-grade-section-mapping`;
                const response = await authorizedAxiosInstitute.post(apiUrl, sectionGradeData);
                // await getInstituteGrade();
                // setInstituteGradeList([]);
                setSectionGradeData(initialFormState);

                // setSaveId(response.data.result[0].id);
                setCurrPage(1);
                setGradeNameSort(null);
                setSectionNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                if(error instanceof ZodError) {
                    setError(error.errors);
                } else {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                }
            } finally {
                setLoading(false);
            }
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSectionGradeData({ ...sectionGradeData, [name]: value });

        if (value.trim().length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleClassChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setSectionGradeData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterIds: selectedIds,
            }
        })

        if (selectedIds.length !== 0) {
            setError(prevErrors => prevErrors.filter(error => error.path[0] !== 'instituteGradeMasterIds'));
        }
    }

    const handleReset = () => {
        setSectionGradeData(initialFormState);
        setError([]);
    }


    useEffect(() => {
        if (gradeNameSort === true || gradeNameSort === false) {
            setSectionNameSort(null);
        }
    }, [gradeNameSort])

    useEffect(() => {
        if (sectionNameSort === true || sectionNameSort === false) {
            setGradeNameSort(null);
        }
    }, [sectionNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>App Institute Section Grade Mapping</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-graduation-cap"></i>App Institute Section Grade Mapping</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section :</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleInputChange} value={sectionGradeData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="sectionMasterId" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="instituteGradeMasterIds" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={instituteGradeList.filter(option =>
                                                            sectionGradeData.instituteGradeMasterIds && sectionGradeData.instituteGradeMasterIds.includes(option?.value?.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterIds"
                                                        options={instituteGradeList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleClassChange}
                                                    />
                                                    <ErrorMessage errors={error} field="instituteGradeMasterIds" />
                                                    {/* {error.gradeMasterId && <p style={{ color: 'red' }}>{error.gradeMasterId}</p>} */}
                                                </div>
                                                {/* {sectionGradeData?.map((grade, index) => (
                                                    <>
                                                        <div className="col-md-5">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Class Name :</label>
                                                            <input type="text" className="form-control" id={`lessonName${index}`} name='gradeName' onChange={(e) => handleInputChange(e, index)} value={grade.gradeName} />
                                                            {instituteError && grade.gradeName == "" && <p style={{ color: 'red' }}>{instituteError}</p>}
                                                        </div>
                                                        <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                            <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                        </div>
                                                    </>
                                                ))} */}

                                                {/* <div className="col-md-12 mt-4 mb-1">
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Class Name</button>
                                                    </div>
                                                </div> */}

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: "20px" }} type="button" onClick={addGrade}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" style={{ marginRight: "20px" }} type="button" onClick={handleReset}>Reset</button>

                                                        {/* {
                                                            editId && (<button className="btn btn-success" type="button" onClick={updateGrade} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setSectionGradeList} setCurrPage={setCurrPage} sortingPath={"sectionMasterDetails.sectionName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Class Name
                                                                            <SortIcon sortState={gradeNameSort} setSortState={setGradeNameSort} setData={setSectionGradeList} setCurrPage={setCurrPage} sortingPath={"instituteGradeMasterDetails.gradeName"} />
                                                                        </th>
                                                                        {/* <th scope="col">Action</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((grade, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{grade?.sectionMasterDetails?.sectionName}</td>
                                                                                        <td>{grade?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                        {/* <td>{grade?.createdAt?.split(",")[0]}</td> */}
                                                                                        {/* <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button"
                                                                                                onClick={() => deleteGrade(grade.id)}

                                                                                            > <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td> */}
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Mapping Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={sectionGradeList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AppInstituteSectionGradeMapping;